<script>
import useMobileStyle from '@/mixins/useMobileStyle';
import bem from '@/utils/bem';
import UploadFiles from '@/components/ux/upload/Upload-files.vue';
import { mapActions, mapState } from 'vuex';
import isUrl from '@/utils/isUrl';
import styles from './style.scss';
import BANNER_DEFAULT from './constants';

const b = bem('block-with-custom-products', styles);

export default {
  name: 'BlockWithCustomProducts',
  components: {
    UploadFiles,
  },
  mixins: [useMobileStyle],
  props: {
    currentPage: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultOptions: BANNER_DEFAULT,
      id: null,
      name: 'blockWithCustomProducts',
      title: '',
      titleMobile: '',
      description: '',
      descriptionMobile: '',
      buttonText: '',
      buttonTextMobile: '',
      imageUrl: undefined,
      imageUrlMobile: undefined,
      visibleImage: undefined,
      visibleImageMobile: undefined,
      desktopImage: [],
      mobileImage: [],
      backgroundColor: '',
      backgroundColorMobile: '',
      goldTextMobile: '',
      reviewsRate: 5,
      products: [],
      options: [],
      beforeText: '',
      afterText: '',
      goldText: '',
      goldTextSlide: '',
      goldTextSlideMobile: '',
      price: 0,
      additionalDiscount: 0,
      mainProduct: undefined,
      selectedProductValues: undefined,
      optionsForProduct: [],
      selectedOptionsForMainProduct: undefined,
      productId: 0,
      optionId: 0,
      isPreview: false,
      isMobile: false,
      slides: [],
      indexOfSlide: 0,
      optionsForSlide: [],
      error: {
        image: false,
        imageMobile: false,
        goldTextSlide: false,
        goldTextSlideMobile: false,
      },
    };
  },
  methods: {
    b,
    isUrl,
    ...mapActions({
      getPageContentAction: 'pageContent/getPageContent',
      createOrEditPageContentAction: 'pageContent/createOrEditPageContent',
      createOrEditSlideAction: 'pageContent/createOrEditSlide',
      deleteSlideAction: 'pageContent/deleteSlide',
    }),
    checkForm() {
      this.isPreview = false;
    },
    checkDesktopReview() {
      this.isPreview = true;
      this.isMobile = false;
    },
    checkMobileReview() {
      this.isPreview = true;
      this.isMobile = true;
    },
    checkImage(image, defaultValue) {
      if (isUrl(image)) {
        return [image];
      }
      return defaultValue;
    },
    addSlide() {
      this.slides = [
        ...this.slides, {
          imageUrl: undefined,
          imageUrlMobile: undefined,
          goldTextSlide: '',
          goldTextSlideMobile: '',
        },
      ];
      this.indexOfSlide = this.slides.length - 1;
    },
    deleteSlide() {
      if (this.slides[this.indexOfSlide].id) {
        this.deleteSlideAction(this.slides[this.indexOfSlide].id);
      }
      this.slides = this.slides.filter((_, index) => index !== this.indexOfSlide);
      this.indexOfSlide = 0;
      this.getPageContentAction(this.currentPage.value);
    },
    saveSlide() {
      const payload = {
        page: this.currentPage.value,
        imageUrl: this.imageUrl,
        imageUrlMobile: this.imageUrlMobile,
        goldText: this.goldTextSlide,
        goldTextMobile: this.goldTextSlideMobile,
      };
      if (this.slides && this.slides.length && this.slides[this.indexOfSlide].id) {
        payload.id = this.slides[this.indexOfSlide].id;
      } else {
        payload.contentId = this.id;
      }
      this.createOrEditSlideAction(payload);
    },
    saveData() {
      const data = {
        name: this.name,
        pageKey: this.currentPage.value,
        title: this.title,
        titleMobile: this.titleMobile,
        description: this.description,
        descriptionMobile: this.descriptionMobile,
        buttonText: this.buttonText,
        buttonTextMobile: this.buttonTextMobile,
        backgroundColor: this.backgroundColor,
        backgroundColorMobile: this.backgroundColorMobile,
        beforeText: this.beforeText,
        afterText: this.afterText,
        goldText: this.goldText,
        productId: this.productId,
        optionId: this.optionId,
        imageUrl: [''],
        imageUrlMobile: [''],
        videoUrl: '',
        isShowVideo: false,
        index: 0,
        blocks: this.blocks,
      };
      const payload = {
        id: this.id,
        page: this.currentPage.value,
        params: data,
      };
      this.createOrEditPageContentAction(payload);
    },
  },
  computed: {
    ...mapState({
      pageContent: (state) => state.pageContent.pageContent,
    }),
  },
  mounted() {
    this.getPageContentAction(this.currentPage.value);
  },
  watch: {
    currentPage(newV, prewV) {
      if (newV !== prewV) {
        this.getPageContentAction(newV.value);
      }
    },
    pageContent(newV) {
      if (newV && Object.keys(newV).length) {
        const blockWithCustomProducts = newV.filter((block) => block.name === 'blockWithCustomProducts')[0];
        this.id = blockWithCustomProducts.id;
        this.title = blockWithCustomProducts.title;
        this.titleMobile = blockWithCustomProducts.titleMobile;
        this.description = blockWithCustomProducts.description;
        this.descriptionMobile = blockWithCustomProducts.descriptionMobile;
        this.slides = newV.find((block) => block.name === 'blockWithCustomProducts').blocks.sort((a, c) => a.id - c.id);
        if (this.slides.length > 0) {
          this.imageUrl = this.slides[this.indexOfSlide].imageUrl;
          this.imageUrlMobile = this.slides[this.indexOfSlide].imageUrlMobile;
          this.goldTextSlide = this.slides[this.indexOfSlide].goldText;
          this.goldTextSlideMobile = this.slides[this.indexOfSlide].goldTextMobile;
          this.visibleImage = this.checkImage(this.slides[this.indexOfSlide].imageUrl, '');
          this.desktopImage = this.checkImage(this.slides[this.indexOfSlide].imageUrl, []);
          this.visibleImageMobile = this.checkImage(this.slides[this.indexOfSlide].imageUrlMobile, '');
          this.mobileImage = this.checkImage(this.slides[this.indexOfSlide].imageUrlMobile, []);
        } else {
          this.imageUrl = '';
          this.imageUrlMobile = '';
          this.goldTextSlide = '';
          this.goldTextSlideMobile = '';
          this.visibleImage = '';
          this.desktopImage = [];
          this.visibleImageMobile = '';
          this.mobileImage = [];
        }
      } else {
        this.id = '';
        this.title = '';
        this.titleMobile = '';
        this.description = '';
        this.descriptionMobile = '';
        this.imageUrl = '';
        this.imageUrlMobile = '';
        this.visibleImage = '';
        this.desktopImage = [];
        this.visibleImageMobile = '';
        this.mobileImage = [];
      }
    },
    desktopImage(newV) {
      if (typeof newV === 'object' && newV.length === 0) {
        this.visibleImage = this.defaultOptions.imageUrl;
        this.imageUrl = '';
      }
    },
    mobileImage(newV) {
      if (typeof newV === 'object' && newV.length === 0) {
        this.visibleImageMobile = this.defaultOptions.imageUrlMobile;
        this.imageUrlMobile = '';
      }
    },
    indexOfSlide(newV, prewV) {
      if (newV !== prewV) {
        this.imageUrl = this.slides[this.indexOfSlide].imageUrl;
        this.imageUrlMobile = this.slides[this.indexOfSlide].imageUrlMobile;
        this.goldTextSlide = this.slides[this.indexOfSlide].goldText;
        this.goldTextSlideMobile = this.slides[this.indexOfSlide].goldTextMobile;
        this.visibleImage = this.checkImage(this.slides[this.indexOfSlide].imageUrl, '');
        this.desktopImage = this.checkImage(this.slides[this.indexOfSlide].imageUrl, []);
        this.visibleImageMobile = this.checkImage(this.slides[this.indexOfSlide].imageUrlMobile, '');
        this.mobileImage = this.checkImage(this.slides[this.indexOfSlide].imageUrlMobile, []);
      }
    },
    slides: {
      handler(newV, prewV) {
        if (newV && newV !== prewV) {
          this.optionsForSlide = newV.map((_, index) => ({
            label: index + 1,
            value: index,
          }));
        }
      },
      deep: true,
    },
  },
};
</script>

<template>
  <div class="top-buttons">
    <a-button
      size="large"
      class='buttons-menu-item'
      @click="checkForm()"
      :type="!isPreview ? 'primary' : 'default'"
    >
      Form for data
    </a-button>
    <a-button
      size="large"
      class='buttons-menu-item'
      @click="checkDesktopReview()"
      :type="isPreview && !isMobile ? 'primary' : 'default'"
    >
      Desktop Preview
    </a-button>
    <a-button
      size="large"
      class='buttons-menu-item'
      @click="checkMobileReview()"
      :type="isPreview && isMobile ? 'primary' : 'default'"
    >
      Mobile Preview
    </a-button>
  </div>
  <div  v-if="!isPreview" class="wrap">
    <div class="row">
      <div class="column">
        <h4>Desktop Title:</h4>
        <a-input
          placeholder="Enter here desktop title"
          style="width: 552px"
          v-model:value="title"
        />
      </div>
      <div class="column">
        <h4>Mobile Title:</h4>
        <a-input
          placeholder="Enter here mobile title"
          style="width: 552px"
          v-model:value="titleMobile"
        />
      </div>
    </div>
    <div class="row">
      <div class="column">
        <h4>Desktop Description:</h4>
        <a-textarea
          placeholder="Enter here desktop description"
          style="width: 552px"
          v-model:value="description"
          :auto-size="{ minRows: 2, maxRows: 5 }"
        />
      </div>
      <div class="column">
        <h4>Mobile Description:</h4>
        <a-textarea
          placeholder="Enter here mobile description"
          style="width: 552px"
          v-model:value="descriptionMobile"
          :auto-size="{ minRows: 2, maxRows: 5 }"
        />
      </div>
    </div>
    <div class="row button">
      <div class="column">
        <h4>Slider's list:</h4>
        <div class="row">
          <a-select
            style="width: 200px"
            :options="optionsForSlide"
            v-model:value="indexOfSlide"
          />
          <a-button
            type="primary"
            @click="saveSlide()"
          >
            Save slide
          </a-button>
          <a-button
            @click="addSlide()"
            :disabled="slides.length >= 4"
          >
            Add new slide
          </a-button>
          <a-button
            type="primary"
            :disabled="slides.length < 2"
            @click="deleteSlide()"
          >X</a-button>
        </div>
        <div class="row">
          <div class="column">
            <h4>Download image for desktop:</h4>
            <upload-files
              :files="desktopImage"
              :is-multiple="false"
              :on-change="(value) => {
                this.desktopImage = value;
                this.imageUrl = value;
              }"
            />
          </div>
          <div class="column">
            <h4>Download image for mobile:</h4>
            <upload-files
              :files="mobileImage"
              :is-multiple="false"
              :on-change="(value) => {
                this.mobileImage = value
                this.imageUrlMobile = value;
              }"
            />
          </div>
        </div>
        <div class="row">
          <div class="column" style="width: 250px">
            <h4>Card title text:</h4>
            <a-input
              placeholder="Enter here desktop gold text"
              style="width: 250px"
              v-model:value="goldTextSlide"
            />
          </div>
          <div class="column" style="width: 250px">
            <h4>Card description text:</h4>
            <a-input
              placeholder="Enter here mobile gold text"
              style="width: 250px"
              v-model:value="goldTextSlideMobile"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row button">
      <a-button
        @click="saveData()"
        type="primary"
      >
        Save
      </a-button>
    </div>
  </div>
  <div v-if="isPreview" :class="b('', { isMobile })">
    <h1 :class="b('title', { isMobile })" >
      {{ isMobile
      ? titleMobile || defaultOptions.titleMobile
      : title || defaultOptions.title
      }}
    </h1>
    <div :class="b('description', { isMobile })">
      {{ isMobile
      ? descriptionMobile || defaultOptions.descriptionMobile
      : description || defaultOptions.description
      }}
    </div>
    <div
      :class="b('custom-container', { isMobile })"
    >
      <div
        :class="b('custom-card', { isMobile })"
        v-for="(slide, index) in slides"
        :key="slide.contentId"
      >
        <img
          :src="isMobile
              ? slide.imageUrlMobile || defaultOptions.blocks[index].imageUrlMobile
              : slide.imageUrl || defaultOptions.blocks[index].imageUrl"
          alt="customImage"
          :class="b('image', { isMobile })"
        />
        <div :class="b('card-block', { isMobile })">
          <h4 :class="b('card-title', { isMobile })">
            {{ slide.goldText}}
          </h4>
          <p :class="b('card-description', { isMobile })">
            {{ slide.goldTextMobile }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import 'src/styles/variables.scss';
@import 'src/styles/media.scss';
@import 'src/styles/fonts.scss';

.top-buttons {
  width: 1200px;
  margin: 50px auto;
  padding: 0 20px;
}

.buttons-menu-item {
  margin-right: 50px;
}

.wrap{
  width: 1200px;
  margin: 50px auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
}

.row {
  width: 552px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 50px;
  align-items: center;
}

.mini-row {
  width: 250px;
}

.column {
  max-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 5px;
  margin-bottom: 10px;
}

.placeholder {
  font-size: 12px;
  font-style: italic;
}

.button {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}

h4 {
  width: 250px;
}

.wrapper {
  display: flex;
  flex-direction: row;
  gap: 25px;
  align-items: center;
}

.block-with-custom-products {
  width: 1540px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 60px 0;
  margin: 0 auto;

  @include mediaMinMax(1025, $normal) {
    width: vw-full(1540);
    padding: vw-full(60) 0;
  }

  &_isMobile {
    width: 360px;
    background-color: $athens-gray;
    padding: 35px 0 0 0;
  }

  &__title {
    font-size: 40px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 40px;
    letter-spacing: normal;
    text-align: center;
    color: $ebony-clay-gray-color;
    margin-bottom: 35px;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(40);
      line-height: vw-full(40);
      margin-bottom: vw-full(35);
    }

    &_isMobile {
      font-size: 22px;
      line-height: 22px;
      margin-bottom: 13px;
      padding: 0 17px;
    }
  }

  &__description {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.47;
    letter-spacing: normal;
    text-align: center;
    color: $main-gray-color;
    max-width: 1050px;
    margin-bottom: 60px;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(16);
      max-width: vw-full(1050);
      margin-bottom: vw-full(60);
    }

    &_isMobile {
      font-size: 15px;
      margin-bottom: 30px;
      padding: 0 17px;
    }
  }

  &__custom-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(24);
    }

    &_isMobile {
      padding: 0 17px 35px 17px;
      gap: 10px;
      justify-content: flex-start;
      overflow-x: scroll;
      width: 100%;
    }
  }

  &__custom-card {
    display: flex;
    flex-direction: column;
    width: 368px;
    height: 474px;
    padding: 9px;
    background-color: $white-color;
    box-shadow: 4.9px 4.9px 9.9px 3.1px rgba(215, 232, 240, 0.75);

    @include mediaMinMax(1025, $normal) {
      width: vw-full(368);
      height: vw-full(474);
      padding: vw-full(9);
    }

    &_isMobile {
      box-shadow: none !important;
      width: 203px;
      height: 258px;
      padding: 5px;
    }
  }

  &__image {
    width: 349px;
    height: 274px;
    min-height: 274px;
    background-color: $main-gray-color;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(349);
      height: vw-full(274);
      min-height: vw-full(274);
    }

    &_isMobile {
      width: 194px !important;
      height: 135px !important;
      min-height: 135px !important;
    }
  }

  &__card-block {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    gap: 7px;
    margin-top: 35px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(7);
      margin-top: vw-full(35)
    }

    &_isMobile {
      gap: 2px;
      margin-top: 22px;
    }
  }

  &__card-title {
    font-size: 35px;
    font-weight: 700;
    line-height: 1;
    text-align: center;

    text-transform: none !important;
    color: $ebony-clay-gray-color !important;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(35);
    }

    &_isMobile {
      font-size: 18px;
      height: 16px;
    }
  }

  &__card-description {
    font-size: 17px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.35;
    letter-spacing: normal;
    text-align: center;
    color: $main-gray-color;
    font-family: $font-family-montserrat;

    @include mediaMinMax(1025, $normal) {
      line-height: vw-full(1.35);
      font-size: vw-full(17);
    }

    &_isMobile {
      font-size: 13px;
      line-height: 20px;
    }
  }
}
</style>
